import React from 'react';

import Pagination from 'Components/Pagination';
import EmptyList from 'Components/EmptyList';

import Row from './Row';
import FiltersSection from './FiltersSection';
import TableHeader from './TableHeader';

const SEARCHABLE_FIELDS = ['id', 'description'];

export default class ComponentList extends React.Component {
  defaultState = {
    activePage: 1,
    selectedRowsCount: 10,
    sortedBy: 'id',
    sortAsc: -1,
    filter: {},
    searchString: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      activePage: 1,
      selectedRowsCount: 10,
      sortedBy: 'id',
      sortAsc: -1,
      filter: {},
      searchString: '',
    };
  }

  _handleActivePageChange = activePage => {
    this.setState({ activePage });
  };

  _sortList = (a, b) => {
    const { sortedBy, sortAsc } = this.state;

    switch (sortedBy) {
      case 'id':
        return +a.id > +b.id ? sortAsc : -sortAsc;
      default:
        return (a[sortedBy] || ' ').toString().toLowerCase().replace(/\s+/g, ' ') >
          (b[sortedBy] || ' ').toString().toLowerCase().replace(/\s+/g, ' ')
          ? sortAsc
          : -sortAsc;
    }
  };

  handleSort = sortedBy => () => {
    this.setState(prevState => ({
      sortedBy,
      sortAsc: prevState.sortedBy === sortedBy ? -prevState.sortAsc : 1,
      activePage: 1,
    }));
  };

  _filterList = componentList => {
    const { filter, searchString } = this.state;

    const doesSearchableFieldsContainSearchString = element => {
      for (let searchableFieldIndex in SEARCHABLE_FIELDS) {
        if (element[SEARCHABLE_FIELDS[searchableFieldIndex]]) {
          if (
            element[SEARCHABLE_FIELDS[searchableFieldIndex]]
              .toString()
              .toLowerCase()
              .includes(searchString.toLowerCase())
          )
            return true;
        }
      }
      return false;
    };

    return componentList.filter(element => {
      for (let filterFieldName in filter) {
        if (element[filterFieldName].toLowerCase() !== filter[filterFieldName].toLowerCase()) {
          return false;
        }
      }
      return !searchString || doesSearchableFieldsContainSearchString(element);
    });
  };

  handleSearchStringInput = value => {
    this.setState({ searchString: value, activePage: 1 });
  };

  handleSelectFilter = filterFieldName => filterElement => {
    let { filter } = this.state;
    const newFilterFieldValue = filterElement.value !== undefined ? filterElement.value : filterElement;

    if (newFilterFieldValue === 'All') delete filter[filterFieldName];
    else filter[filterFieldName] = newFilterFieldValue;

    this.setState({ filter: filter, activePage: 1 });
  };

  _getList = () => {
    const { activePage, selectedRowsCount, sortedBy } = this.state;
    const { user, components } = this.props;

    let resultList = [];
    let resultLength = 0;
    const filteredList = this._filterList(components).sort(this._sortList);
    const sliceFrom = (activePage - 1) * selectedRowsCount;
    const sliceTo = +selectedRowsCount ? activePage * selectedRowsCount : filteredList.length;

    if (!filteredList.length) {
      resultList = [<EmptyList key="empty">No components found with selected filters.</EmptyList>];
    } else {
      resultLength = filteredList.length;
      resultList = filteredList.slice(sliceFrom, sliceTo).map((component, index) => {
        return <Row key={component.id} user={user} sortedBy={sortedBy} component={component} />;
      });
    }

    return {
      resultList,
      resultLength,
    };
  };

  render() {
    const { components } = this.props;

    if (!components.length) return null;

    const { activePage, selectedRowsCount, filter, sortedBy, sortAsc, searchString } = this.state;
    const { resultList, resultLength } = this._getList();

    return (
      <section className='scene_section'>
        <header>Component List</header>

        <FiltersSection
          handleSelectFilter={this.handleSelectFilter}
          filterState={filter}
          searchString={searchString}
          handleSearchStringInput={this.handleSearchStringInput}
        />

        <TableHeader handleSortClick={this.handleSort} order={sortAsc === 1} sortedBy={sortedBy} />

        <div className='list__wrapper'>{resultList}</div>
        {components.length > 10 && (
          <footer className='list-scene__footer _jc_center'>
            <Pagination
              className='_height_80'
              activePage={activePage}
              handleClick={this._handleActivePageChange}
              allRowsCount={resultLength}
              selectedRowsCount={selectedRowsCount}
            />
          </footer>
        )}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/ComponentFamily/Details/ComponentList/index.jsx